import { useRef, useState } from 'react'
import i18n from 'i18next'

import { useSettingsStore } from 'stores/settingsStore'
import { useAuthStore } from 'stores/authStore'
import { useOutsideClick } from 'hooks/useOutsideClick'
import { getData } from 'helpers/api'

import Button from 'components/Button'

import style from './index.module.scss'

const Languages = () => {
  const { settings } = useSettingsStore()
  const { setAuth, auth } = useAuthStore()
  const [toggle, setToggle] = useState(false)

  const blockRef = useRef(null)

  const handleChange = (el) => {
    let a = {
      ...auth,
      language: el
    }

    setAuth(a)
    i18n.changeLanguage(el.code)
    localStorage.setItem('language', JSON.stringify(el))
    setToggle(false)

    getData(`lang/${el.code}/`).then((data) => {
      if (data.code === '0') {
        window.location.reload()
      }
    })
  }

  useOutsideClick(
    blockRef,
    () => {
      setToggle(false)
    },
    toggle
  )

  return (
    <div
      ref={blockRef}
      className={style.block}
    >
      <button
        type="button"
        onClick={() => setToggle(!toggle)}
        className={style.toggle}
        aria-label={auth?.language?.text}
      >
        <img
          src={`/images/countries/${auth?.language?.code}.svg`}
          className={style.image}
          alt={`${auth?.language?.text}`}
          loading="lazy"
        />
      </button>
      {
        (toggle && settings?.languages?.length > 1) &&
        <div className={style.dropdown}>
          {
            settings?.languages?.map((el, idx) =>
              auth?.language?.code !== el.code &&
                <Button
                  key={idx}
                  aria-label={el.text}
                  classes={['secondary', 'md']}
                  onChange={() => handleChange(el)}
                >
                  <p className={style.icon}>
                    <img
                      src={`/images/countries/${el.code}.svg`}
                      className={style.image}
                      alt={`${el.text}`}
                      loading="lazy"
                    />
                  </p>
                  {el.text}
                </Button>
            )
          }
        </div>
      }
    </div>
  )
}

export default Languages
